import { Link } from "react-router-dom";
import { FiMapPin, FiPhone, FiMail, FiClock } from "react-icons/fi";
import { FaInstagram, FaFacebookF, FaYoutube } from "react-icons/fa";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__top">
        <div className="footer__brand">
          <Link to="/" className="footer__logo">FIRM<span>FIT</span>FACTORY</Link>
          <p className="footer__tagline">
            A premium strength &amp; fitness centre in Peelamedu, Coimbatore — built for people who train with purpose.
          </p>
          <div className="footer__socials">
            <a href="https://instagram.com/firmfitfactory" aria-label="Instagram (placeholder link)"><FaInstagram aria-hidden="true" /></a>
            <a href="https://facebook.com/firmfitfactory" aria-label="Facebook (placeholder link)"><FaFacebookF aria-hidden="true" /></a>
            <a href="https://youtube.com/@firmfitfactory" aria-label="YouTube (placeholder link)"><FaYoutube aria-hidden="true" /></a>
          </div>
        </div>

        <div className="footer__col">
          <h3>Explore</h3>
          <Link to="/about">About</Link>
          <Link to="/programs">Programs</Link>
          <Link to="/trainers">Trainers</Link>
          <Link to="/membership">Membership</Link>
          <Link to="/gallery">Gallery</Link>
        </div>

        <div className="footer__col">
          <h3>Programs</h3>
          <Link to="/programs#strength-training">Strength Training</Link>
          <Link to="/programs#functional-training">Functional Training</Link>
          <Link to="/programs#weight-management">Weight Management</Link>
          <Link to="/programs#personal-training">Personal Training</Link>
        </div>

        <div className="footer__col footer__contact">
          <h3>Visit Us</h3>
          <p><FiMapPin aria-hidden="true" /> Maheshwari Nagar, Vilangurichi Road, 4th Street, Peelamedu, Coimbatore – 641004, Tamil Nadu</p>
          <p><FiPhone aria-hidden="true" /> <a href="tel:+919500886368">+91 95008 86368</a></p>
          <p><FiMail aria-hidden="true" /> <span>info@firmfitfactory.com (placeholder)</span></p>
          <p><FiClock aria-hidden="true" /> <span>Hours placeholder — confirm before publishing</span></p>
        </div>
      </div>

      <div className="container footer__bottom">
        <p>
          © {new Date().getFullYear()} Firm Fit Factory. All rights reserved.
        </p>

        <p className="footer__note">
          Developed by{" "}
          <a
            href="https://mpeoples.in/"
            target="_blank"
            rel="noopener noreferrer"
          >
            MPeoples Business Solutions Pvt. Ltd.
          </a>
        </p>
      </div>
    </footer>
  );
}
